<div class="col-sm-2 col-centered">
    <div class="input-group" style="padding-top: 10px">
        <input id="zipcode" type="text" class="form-control" placeholder="Enter zipcode" maxlength="5" required #zipcode>
        <span class="input-group-btn"><button id="fetch-button" class="btn btn-default" type="button"
                                              (click)="fetchZipCodeInfo(zipcode.value)">
            <span class="glyphicon glyphicon-search"></span></button></span>
    </div><!-- /input-group -->
</div>